import React from "react";
import LrMasterReport from "../LrMasterReport";

export default function ReportLrMaster({ sessionObject }) {
  if (!sessionObject.sessionVariables["modules"].includes("report-lr-master")) {
    return;
  }
  return (
    <div className="page-bilty">
      <LrMasterReport sessionObject={sessionObject} />
    </div>
  );
}
